export default __webpack_public_path__ + "static/aslihan-ozturk-c0298cd5ed5774d6a12507bcf5dc419d.png";